











































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InvoiceSyncSettingForm from '../invoice-sync-setting-form/invoice-sync-setting-form.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

@Component({
  name: 'bpc-invoice-sync-modal',
  components: {
    'bpc-invoice-sync-setting-form': InvoiceSyncSettingForm,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class InvoiceSyncModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'invoice-sync-confirmation-modal' }) readonly modalId: string;
  @Prop({ type: String }) readonly uxSessionCode: string;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly invoiceSyncRequestSent: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSyncingInvoices: boolean;
  @Prop({ type: Boolean, default: false }) readonly showInvoiceSyncSettingForm: boolean;
  @Prop({ type: Boolean, default: false }) readonly invoiceSyncFileGenerated: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly invoiceSyncEventsSuccess: object[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly invoiceSyncEventsError: object[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selection: object[];

  // DATA
  loadingAnalysis: boolean = true;
  analysis = null;
  analysisAccepted: boolean = false;
  public errorReportPerPage: number = 5;
  public errorReportCurrentPage: number = 1;
  public successReportPerPage: number = 5;
  public successReportCurrentPage: number = 1;

  // LIFECYCLE
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // COMPUTED
  get modalConfig() {
    return {
      id: 'modal-invoices-to-sync-items',
      title: this.$t('global.modals.invoices-to-sync-items.title') as string,
      body: this.$t('global.modals.invoices-to-sync-items.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  get errorReportRows() {
    return this.invoiceSyncEventsError.length;
  }
  get errorReportCurrentList() {
    const start = (this.errorReportCurrentPage - 1) * this.errorReportPerPage;
    const end = start + this.errorReportPerPage;
    return this.invoiceSyncEventsError.slice(start, end);
  }

  get successReportRows() {
    return this.invoiceSyncEventsSuccess.length;
  }
  get successReportCurrentList() {
    const start = (this.successReportCurrentPage - 1) * this.successReportPerPage;
    const end = start + this.successReportPerPage;
    return this.invoiceSyncEventsSuccess.slice(start, end);
  }

  get hasAnalysisToShow() {
    return this.analysis != null && this.analysis.hasWarnings;
  }

  get analysisBodyText() {
    return this.$t('global.modals.invoices-to-sync-items.warnings', {
      syncService: this.$t(`global.fields.sync_service.${this.analysis.syncService}.label`),
    }) as string;
  }

  get analysisTableFields() {
    return [
      {
        key: 'documentNumber',
        label: this.$t('global.invoice.label'),
      },
      {
        key: 'contact',
        label: this.$t('global.contact.label'),
      },
      {
        key: 'contactVatNumber',
        label: this.$t('contacts.contacts.vat_number.label'),
      },
      {
        key: 'contactExternalReference',
        label: this.$t('contacts.contacts.external_reference.label'),
      },
    ];
  }

  // METHODS
  onCloseModal() {
    this.$emit('close-modal');
  }
  onConfirmSyncAllInvoices() {
    this.$emit('confirm-sync-all-invoices');
  }
  onConfirmSyncInvoices() {
    this.$emit('confirm-sync-invoices');
  }

  onDownloadSyncFile() {
    this.$emit('download-sync-file');
  }

  openModal() {
    this.$bvModal.show(this.modalId);
    this.getAnalysis();
  }

  async getAnalysis() {
    this.loadingAnalysis = true;
    this.analysis = null;
    const res = await this.$bpcApi
      .get(`${this.$bpcApiRouteHelper.getEntityPath('invoice-sync-item')}/analysis`, {
        params: {
          invoices: this.selection,
        },
      })
      .toPromise();
    this.analysis = res?.data;
    this.loadingAnalysis = false;
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
